import { render } from "./moduleNews.vue?vue&type=template&id=9d593c4a"
import script from "./moduleNews.vue?vue&type=script&lang=js"
export * from "./moduleNews.vue?vue&type=script&lang=js"

import "./moduleNews.vue?vue&type=style&index=0&id=9d593c4a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__